/* RESPONSIBLE TEAM: team-data-foundations */
import type AppService from 'embercom/services/app-service';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class AuthenticationIndexRoute extends SettingsRoute {
  @service declare store: $TSFixMe;
  @service declare appService: AppService;

  reactEnabled() {
    return this.appService.app.canUseFeature('tdf-authentication-react-list-page');
  }

  async model() {
    let tokens = await this.store.findAll('custom-authentication/token');
    return tokens.toArray();
  }
}

export default ReactRoute(AuthenticationIndexRoute);
